/**
 * Helper: Breakpoints
 * -----------------------------------------------------------------------------
 * Global configuration for consistent values for media queries in scripts.
 * - These values should mirror the breakpoint values defined in `grid.scss`.
 */
export const values = {
  tiny: 320,
  small: 576,
  medium: 768,
  large: 1024,
  wide: 1200
};
export default {
  tiny: "".concat(values.tiny, "px"),
  small: "".concat(values.small, "px"),
  medium: "".concat(values.medium, "px"),
  large: "".concat(values.large, "px"),
  wide: "".concat(values.wide, "px")
};